import { Produit } from '../../habilitation/models/produit.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationIgp {
    static jsonMap = {
        id: { key: 'id', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        surface: { key: 'surface' },
        volume: { key: 'volumeNetRevendiqueEncours' },
        mention: { key: 'mention', optional: true, default: '' },
        surfaceModifiee: { key: 'surfaceModifiee', optional: true, default: 0 },
        volumeModifie: { key: 'volumeNetRevendiqueEncoursModifie', optional: true, default: 0 }
        // Note: produit is not mapped (kept as a plain property)
    };

    id: number;
    codeProduit: string;
    surface: number;
    volume: number;
    mention: string;

    produit: Produit = undefined;

    surfaceModifiee: number;
    volumeModifie: number;
}
